var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-vstack"},[_c('StatsGrowth',{attrs:{"api":_vm.api,"title":_vm.title}}),_c('Growth')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }